import Items, { defaultConfigComponent as ItemsConfig } from '../Items/Items';
import { IConfigComponent } from '@ts/ui-models';

export const defaultConfigComponent = (): IConfigComponent => {
  return { ...ItemsConfig, componentId: 'vehicles', entity: 'vehicle', filtersFetchData: { vehicle: { isAlive: true } } };
};

const Vehicles = props => {
  const defaultProps = {
    flavorId: 'vehicle',
    title: 'Vehicles',
    nameColumns: ['defaultLocation', 'currentLocation', 'lastPosition'],
  };
  return <Items configComponent={defaultConfigComponent()} {...defaultProps} {...props} />;
};

export default Vehicles;
